import { useWorkspace } from "lib/tools/createWorkspace/useWorkspace";

export const StaffSchedulerWorkspace = () => {
  const workspace = useWorkspace({ name: "staff-scheduler", width: 3 });

  return workspace;
};
